module.exports = __webpack_public_path__ + "img/AJBlogo.c08e8bf0.png";